import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@mui/material'
import React from 'react'
import {
  Controller,
  useFieldArray,
  useFormContext,
  useWatch
} from 'react-hook-form'

import { comparators, types } from 'components/scenarios/utils/criteria-utils'
import { StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'
import { useTranslation } from 'hooks/use-translation'

export const StatusCheckPredicateConfiguration: React.FC = () => {
  const { trans } = useTranslation()
  const { control } = useFormContext<StatusCheckFormValues>()

  const [predicates] = useWatch<StatusCheckFormValues>({
    control,
    name: ['predicates']
  })

  const { fields } = useFieldArray<StatusCheckFormValues>({
    control,
    name: 'predicates'
  })

  return (
    <Grid container direction="column" rowSpacing={2}>
      {fields.map((field, index) => (
        <Grid key={field.id} container item direction="row" spacing={2}>
          <Grid item>
            <FormControl>
              <Controller
                control={control}
                name={`predicates.${index}.jpQuery`}
                render={({ field: controllerRenderField }) => (
                  <TextField
                    {...controllerRenderField}
                    helperText={trans(
                      'form.save_status_checks.predicate_configuration.key.text_field.helper_text'
                    )}
                    label={trans(
                      'form.save_status_checks.predicate_configuration.key.text_field.label'
                    )}
                    variant="outlined"
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl sx={{ minWidth: 135 }}>
              <InputLabel>
                {trans(
                  'form.save_status_checks.predicate_configuration.type.text_field.label'
                )}
              </InputLabel>
              <Controller
                control={control}
                name={`predicates.${index}.type`}
                render={({ field: controllerRenderField }) => (
                  <Select
                    {...controllerRenderField}
                    label={trans(
                      'form.save_status_checks.predicate_configuration.type.text_field.label'
                    )}
                    variant="outlined"
                  >
                    {Object.keys(types).map((predicateType) => (
                      <MenuItem
                        key={predicateType}
                        data-testid={`shared-status-check-evaluation-predicate-type-${predicateType.toLowerCase()}`}
                        value={predicateType}
                      >
                        {predicateType}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl sx={{ minWidth: 135 }}>
              <InputLabel>
                {trans(
                  'form.save_status_checks.predicate_configuration.comparator.text_field.label'
                )}
              </InputLabel>
              <Controller
                control={control}
                name={`predicates.${index}.comparator`}
                render={({ field: controllerRenderField }) => (
                  <Select
                    {...controllerRenderField}
                    label={trans(
                      'form.save_status_checks.predicate_configuration.comparator.text_field.label'
                    )}
                    variant="outlined"
                  >
                    {predicates[0].type
                      ? types[predicates[0].type].comparators.map(
                          (comparator) => (
                            <MenuItem
                              key={comparator}
                              data-testid={`shared-status-check-evaluation-predicate-key-comparator-${comparator.toLowerCase()}`}
                              value={comparator}
                            >
                              {comparators[comparator].label}
                            </MenuItem>
                          )
                        )
                      : []}
                  </Select>
                )}
              />
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl>
              <Controller
                control={control}
                name={`predicates.${index}.rValue`}
                render={({ field: controllerRenderField }) => (
                  <TextField
                    {...controllerRenderField}
                    helperText={trans(
                      'form.save_status_checks.predicate_configuration.value.text_field.helper_text'
                    )}
                    label={trans(
                      'form.save_status_checks.predicate_configuration.value.text_field.label'
                    )}
                    variant="outlined"
                  />
                )}
              />
            </FormControl>
          </Grid>
        </Grid>
      ))}
    </Grid>
  )
}
